import { useEffect, useRef, useState } from "react";
import { router, useLocalSearchParams } from "expo-router";
import LScreen from "@components/LScreen";
import LText from "@components/LText";
import LButton from "@components/LButton";
import PickExternalPlaylists from "./PickExternalPlaylists";
import { useSetupMusicImport } from "./useSetupMusicImport";

export default function ImportCallbackScreen() {
  const { data64 } = useLocalSearchParams<{ data64?: string }>();
  const { finishCallback, start, busy, message, selectedService } =
    useSetupMusicImport();
  const [legacy, setLegacy] = useState(false);
  const [unexpectedError, setUnexpectedError] = useState(false);
  const handled = useRef<string | null>(null);
  useEffect(() => {
    const callbackKey = data64 ?? "missing";
    if (handled.current === callbackKey) return;
    handled.current = callbackKey;
    finishCallback(data64)
      .then((result) => {
        if (result === undefined) setLegacy(true);
        else if (result) router.replace("/onboarding/notification");
      })
      .catch(() => setUnexpectedError(true));
  }, [data64, finishCallback]);

  if (legacy) return <PickExternalPlaylists />;
  return (
    <LScreen safeArea gap="m1" justifyContent="center" px="m1">
      <LText accessibilityLiveRegion="polite">
        {message ??
          (unexpectedError
            ? "We couldn’t finish connecting. Please try again."
            : "Starting your playlist import…")}
      </LText>
      {message && selectedService && (
        <LButton
          sentryEventName={null}
          label="Try again"
          enabled={!busy}
          onPress={() => start(selectedService)}
        />
      )}
      {(message || unexpectedError) && (
        <LButton
          sentryEventName={null}
          label="Pick music genres"
          enabled={!busy}
          onPress={() => router.replace("/onboarding/pick-genres")}
        />
      )}
    </LScreen>
  );
}
